import { Box, Skeleton, Text } from '@mantine/core';
import { type FC } from 'react';
import { useUnit } from 'effector-react';
import { $isPayoutTraderActive, usePayoutRate } from '~/entities/payout';
import { formatAmount } from '~/shared/lib/utils/formatAmount';
import styles from './Rate.module.css';

export const Rate: FC = () => {
    const { isPayoutTraderActive } = useUnit({
        isPayoutTraderActive: $isPayoutTraderActive,
    });

    const { data: rate, isLoading } = usePayoutRate({
        enabled: isPayoutTraderActive,
    });

    const formattedRate = formatAmount(rate);
    const isVisible = isLoading || !formattedRate;

    return (
        <Box
            className={styles.root}
            bdrs='lg'
            w='auto'
        >
            <Text
                fz={14}
                fw={700}
                component='span'
            >
                <Skeleton
                    visible={isVisible}
                    radius='sm'
                    w='auto'
                >
                    <span>
                        {formattedRate} {' ₽/USDT'}
                    </span>
                </Skeleton>
            </Text>
        </Box>
    );
};
